import React, { useState } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { ArrowLeft, ArrowRight, ChevronDown } from 'lucide-react';
import PublicSiteShell, { Reveal, registroHref } from '../components/public/PublicSiteShell';
import { getModulePage } from '../data/publicModulePages';
import { usePublicPlans } from '../hooks/usePublicPlans';

/*
 * Página de detalle de un módulo del sitio público: /funcionalidades/:slug.
 * El contenido de cada módulo vive en src/data/publicModulePages.jsx.
 */
export default function Modulo() {
  const { slug } = useParams();
  const mod = getModulePage(slug);
  const { trialDays } = usePublicPlans();
  const [openFaq, setOpenFaq] = useState(0);

  if (!mod) return <Navigate to="/funcionalidades" replace />;

  return (
    <PublicSiteShell>
      <div className="gst-container">
        <Reveal>
          <Link className="back-link" to="/funcionalidades">
            <ArrowLeft size={14} /> Todas las funcionalidades
          </Link>
        </Reveal>

        <Reveal className="mod-header" as="header">
          <div className="gst-eyebrow gst-eyebrow-mint">{mod.eyebrow}</div>
          <h1>{mod.title}</h1>
          <p>{mod.subtitle}</p>
        </Reveal>

        <section className="mod-section">
          <div className="mod-grid">
            <Reveal className="mod-text">
              {mod.body.map((p) => <p key={p.slice(0, 24)}>{p}</p>)}
              <Link className="gst-btn gst-btn-primary" to={registroHref}>
                Empezar prueba <ArrowRight size={16} />
              </Link>
              <div className="mod-note">{trialDays} días de prueba gratis, sin tarjeta.</div>
            </Reveal>

            <Reveal className="mock-wrap">
              <div className="stack-bg" />
              {mod.mock}
            </Reveal>
          </div>
        </section>
      </div>

      <div className="gana-band">
        <div className="gst-container">
          <Reveal className="gana-head">
            <h3>Ganá tiempo con Gastify</h3>
            <p>Menos tareas manuales, más certeza en {mod.eyebrow.toLowerCase()}.</p>
          </Reveal>
          <div className="gana-grid">
            {mod.gana.map(({ icon: Icon, title, text }) => (
              <Reveal className="gana-item" key={title}>
                <div className="icon-badge"><Icon size={20} /></div>
                <div>
                  <h4>{title}</h4>
                  <p>{text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>

      <div className="gst-container">
        <section className="faq-section">
          <Reveal className="faq-head">
            <div className="gst-eyebrow gst-eyebrow-mint" style={{ marginBottom: 12 }}>Preguntas frecuentes</div>
            <h2>Dudas comunes sobre {mod.eyebrow.toLowerCase()}.</h2>
          </Reveal>
          <div>
            {mod.faqs.map((f, i) => (
              <div className={`faq-item${openFaq === i ? ' open' : ''}`} key={f.q}>
                <button type="button" className="faq-q" onClick={() => setOpenFaq(openFaq === i ? -1 : i)}>
                  <h4>{f.q}</h4><ChevronDown size={20} />
                </button>
                <div className="faq-a"><p>{f.a}</p></div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </PublicSiteShell>
  );
}
